const addressComponentsMap = {
  country: ['country'],
  state: ['administrative_area_level_1'],
  municipality: ['locality'],
  neighborhood: ['sublocality', 'sublocality_level_1'],
  county: ['sublocality_level_2'],
  street: ['route'],
  streetNumber: ['street_number'],
  zipCode: ['postal_code'],
  town: ['postal_town'],
  district: ['neighborhood'],
};

export const intersection = (arrA, arrB) => {
  const setB = new Set(arrB);

  return [...arrA].filter(e => setB.has(e));
};

const getStreet01 = terms => {
  if (terms.length < 4) return undefined;
  if (terms.length > 4)
    return terms
      .map(term => term.value)
      .slice(0, 2)
      .join(', ');
  return terms[0].value;
};

export const getAddressData = terms => {
  if (terms.length < 3) return undefined;
  const street01 = getStreet01(terms);
  const { length, [length - 3]: town, [length - 1]: country } = terms;
  return {
    street01,
    country: country.value,
    town: town.value,
  };
};

const getAddressPropertyByComponentTypes = types => {
  const matchedEntry = Object.entries(addressComponentsMap).filter(entry => {
    return intersection(entry[1], types).length > 0;
  })[0];

  return matchedEntry ? matchedEntry[0] : null;
};

const addressComponentsToAddress = (address, component) => {
  const addressProperty = getAddressPropertyByComponentTypes(component.types);
  if (addressProperty) {
    return {
      ...address,
      [addressProperty]: component.long_name,
    };
  }
  return address;
};

export const getAddressFromPlace = place => {
  const { address_components: addressComponents } = place;

  const address = addressComponents.reduce(addressComponentsToAddress, {
    country: '',
    state: '',
    municipality: '',
    neighborhood: '',
    street: '',
    streetNumber: '',
    zipCode: '',
    county: '',
    town: '',
    district: '',
  });
  return address;
};
